import { Box, Chip, makeStyles, Popover } from '@material-ui/core';
import { formatPercent, PricingInsurance } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { InsuranceProviderLogo } from '@/components/shared/components/Logo/InsuranceProviderLogo/InsuranceProviderLogo';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const PricingInsuranceChip = ({ insurance }: { insurance: PricingInsurance }) => {
  const { palette } = useCustomTheme();
  const { getTextIdTranslation: t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'insurance-details-popover' : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const useStyles = makeStyles({
    label: {
      // margin: '0 4px',
      '& .MuiChip-labelSmall': {
        paddingLeft: '2px',
        paddingRight: '6px',
      },
    },
  });

  const classes = useStyles();

  return (
    <>
      <Chip
        clickable
        onClick={(event: React.MouseEvent<HTMLDivElement>) => setAnchorEl(event.currentTarget)}
        className={classes.label}
        size={'small'}
        icon={<InsuranceProviderLogo size={16} insuranceProvider={insurance.provider} />}
        label={
          <Font variant={'caption'} color={'textPrimary'} style={{ marginLeft: 6 }}>
            <Text tId={`INSURANCE_TYPE_${insurance.type}`} />
          </Font>
        }
        style={{ backgroundColor: palette.grey[50] }}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            padding: 16,
            width: 240,
          },
        }}
      >
        <Box>
          <Font variant="h5" color="title" display="block">
            {t(`INSURANCE_TYPE_${insurance.type}`)}
          </Font>

          <FlexColumn mt={1} gridGap={4} width="100%">
            <FlexRow width="100%">
              <Font variant="body2" display="block">
                <Text tId="INSURANCE_PROVIDER" />
              </Font>
              <Font variant="body2" display="block">
                {t(`INSURANCE_PROVIDER_${insurance.provider}`)}
              </Font>
            </FlexRow>

            {insurance.rappel && (
              <FlexRow width="100%">
                <Font variant="body2" display="block">
                  <Text tId="MERCHANT_FEE" />
                </Font>
                <Font variant="body2" display="block">
                  {formatPercent(insurance.rappel.value)}
                </Font>
              </FlexRow>
            )}

            <FlexRow width="100%">
              <Font variant="body2" display="block">
                <Text tId="INSURANCE_PERCENTAGE" />
              </Font>
              <Font variant="body2" display="block">
                {formatPercent(insurance.cost.value)}
              </Font>
            </FlexRow>
          </FlexColumn>
        </Box>
      </Popover>
    </>
  );
};
